<aside class="main-sidebar">
  <!-- sidebar: style can be found in sidebar.less -->
  <section class="sidebar">
    <!-- Sidebar user panel (optional) -->
    <div class="user-panel">
      <div class="info" style="font-size:20px;padding-bottom:10px;margin-left:-50px;">
        <!-- <p>{{userDetails.first_name}} {{userDetails.last_name}}</p> -->
        <p [hidden]="!userDetails?.first_name">
          {{ userDetails.first_name }} {{ userDetails.last_name }}
        </p>
        <p [hidden]="userDetails?.first_name">Super User</p>
        <br />
        <!-- Status -->
        <!-- <a href="#"><i class="fa fa-circle text-success"></i> Online</a> -->
      </div>
      <div class="pull-right image">
        <!-- <img src="assets/img/user2-160x160.jpg" class="img-circle" alt="User Image">  -->
        <span style="min-height:50px;">&nbsp;</span>
      </div>
    </div>

    <!-- Sidebar Menu -->
    @if (jwt) {
    <ul class="sidebar-menu" data-widget="tree">
      <li class="treeview" id="system" (click)="dropdownMenuClicked('system')">
        <a href="javascript:void(0)">
          <i class="fa fa-cog"></i>
          <span>System</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-down pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li>
            <a routerLink="/user/settings/valet_car_brand">
              <span>Car Brand</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/settings/valet_system_messages">
              <span>System Messages</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="treeview" id="coupon" (click)="dropdownMenuClicked('coupon')">
        <a href="javascript:void(0)">
          <i class="fa fa-tag"></i>
          <span>Coupon</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-down pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li>
            <a routerLink="/user/coupons">
              <span>Add New</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/coupons">
              <span>View All</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="treeview" id="valet" (click)="dropdownMenuClicked('valet')">
        <a href="javascript:void(0)">
          <i class="fa fa-window-maximize"></i>
          <span>Valet</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-down pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">

          <li>
            <a routerLink="/user/valletparking">
              <span>View All</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="treeview" id="reports" (click)="dropdownMenuClicked('reports')">
        <a href="javascript:void(0)">
          <i class="fa fa-bar-chart"></i>
          <span>Reports</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-down pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li>
            <a routerLink="/user/reports/pass_tickets">
              <span>Valet Ticket History</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/guest_tickets">
              <span>Valet Guest Transactions</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/without_charge">
              <span>Valet Staff Report Card</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/valet_staff_list">
              <span>Valet Staff List</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/valet_booth_transaction">
              <span>Valet Booth Transaction</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/car_parked_per_location">
              <span>Car Parked Per Location</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/valet_ticket_revenue">
              <span>Valet Ticket Revenue</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/avg_car_parked_time">
              <span>Avg Car Parked Time</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/avg_car_retrieval_time">
              <span>Avg Car Retrieval Time</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/peak_hour_analysis">
              <span>Peak Hour Analysis</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="treeview" id="validation" (click)="dropdownMenuClicked('validation')">
        <a href="javascript:void(0)">
          <i class="fa fa-check-circle"></i>
          <span>Validation</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-down pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li>
            <a routerLink="/user/reports/valet_shop_details">
              <span>Valet Shop Details</span>
            </a>
          </li>
          <li>
            <a routerLink="/user/reports/valet_validation">
              <span>Valet Validation</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    }
    <!-- /.sidebar-menu -->
  </section>
  <!-- /.sidebar -->
</aside>